import angular from 'angular';

// Pages
import DataUsage from './dataUsage';
import Equipment from './equipment';
import EquipmentNotifications from './equipmentNotifications';
import Groups from './groups';
import List from './list';
import LiveMonitoring from './liveMonitoring';
import Monitoring from './monitoring';
import Organizations from './organizations';
import RcuManagement from './rcuManagement';
import Types from './types';
import Resources from './resources';

import Sites from './sites';
import UserLog from './userLog';
import Users from './users';
import videoMonitoring from './videoMonitoring/VideoMonitoringComponent';

// Shared components

export default angular
  .module('petroCloud.admin', [
    DataUsage,
    Equipment,
    EquipmentNotifications,
    Groups,
    List,
    LiveMonitoring,
    Monitoring,
    Sites,
    Organizations,
    RcuManagement,
    Types,
    Resources,
    UserLog,
    Users,
  ])
  .component(videoMonitoring.name, videoMonitoring)
  .name;
